import { EMPTY_CARD_DATE } from 'shared/custom/constants/commonConstants';

/**
 * Function that converts text to a sequence form. EX: DATA SECURITY to Data security
 * @param text string
 */
export const textTransformToSequence = (text: string) => {
	const lowerCaseText = text.toLowerCase();
	return lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1);
};

export const compare = (a: string | number, b: string | number) => {
	if (a < b) return -1;
	if (a > b) return 1;
	return 0;
};
/* Remove white spaces, normalize, remove diacritical marks unicode blocks, and change it to lower case. */
export const formatText = (text: string) =>
	text
		.trim()
		.replace(/\s+/g, '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase();

/** Check if the date of a card is valid
 *
 *@param {string} expiryDate - The expiration date of the card, on "mm/yy" format
 *@returns {boolean} The date is still valid
 */
export const validateExpDate = (expiryDate = EMPTY_CARD_DATE) => {
	const dateData = expiryDate;
	if (dateData === EMPTY_CARD_DATE) {
		return false;
	}
	if (dateData.indexOf('_') === -1) {
		const date = dateData.split('/');
		const today = new Date();
		const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
		const yy = today
			.getFullYear()
			.toString()
			.substr(today.getFullYear().toString().length - 2);
		if (parseInt(date[0]) > 12) {
			return false;
		}
		if (parseInt(date[1]) > parseInt(yy)) {
			return true;
		}
		if (parseInt(date[1]) === parseInt(yy)) {
			if (parseInt(date[0]) >= parseInt(mm)) {
				return true;
			}
		}
	}
	return false;
};
